export default {
  'USER_LOGGED_IN' (state, user) {
    state.user = user
  },
  'FORM_RESPONSES_DATA' (state, results) {
    state.formResponsesData = results
  },
  'UPDATE_SELECTED_COUNTRY' (state, results) {
    state.selectedCountry = results
  },
  'UPDATE_SELECTED_DEPARTMENT' (state, results) {
    state.selectedDepartment = results
  },
  'ALL_USERS_DATA' (state, results) {
    state.allUsersData = results
  },
  'STOP_LOADING' (state) {
    state.isLoading = false
  },
  'START_LOADING' (state) {
    state.isLoading = true
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js